import { firebaseAuth } from './firebase.js';

const API_BASE = import.meta.env.VITE_API_BASE;

/**
 * Submit a question issue flag.
 * @param {{
 *   questionId:   string,
 *   issueType:    string,
 *   description:  string,
 *   childId:      string|null,
 *   accountEmail: string|null
 * }} payload
 * @returns {Promise<void>}
 */
export async function submitQuestionFlag(payload) {
  const user = firebaseAuth.currentUser;
  const token = user ? await user.getIdToken() : null;
  const res = await fetch(`${API_BASE}/questions/flag`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `Request failed (${res.status})`);
  }
}
